import React from "react";
import styles from "./EntityTableTokens.module.scss";

export const LabelChip = ({ children, active, onClick, color }) => (
  <div
    className={`${styles.chip} ${active ? styles.chipActive : ""}`}
    onClick={onClick}
    role="button"
    style={
      color
        ? {
            "--chip-color": color,
            "--chip-fg": "#ffffff",
            "--chip-border": "transparent",
          }
        : undefined
    }
  >
    {children}
  </div>
);

export const PriorityBadge = ({ level, active, onClick }) => {
  if (!level) return null;
  return (
    <div
      className={`${styles.priorityBadge} ${
        active ? styles.priorityBadgeActive : ""
      }`}
      onClick={onClick}
      role="button"
    >
      ↑
    </div>
  );
};

export const PointsPill = ({ value, active, onClick }) =>
  value ? (
    <span
      className={`${styles.pointsPill} ${active ? styles.pointsPillActive : ""}`}
      onClick={onClick}
      role="button"
    >
      {value}
    </span>
  ) : null;
